import { useEffect, useState } from 'react'
import Header from '../../components/Header'
import Mosaic from '../../components/Mosaic'
import Collection from '../../components/Profile/Collection'
import HorizontalMenu from '../../components/Profile/HorizontalMenu'
import Profile from '../../components/Profile/Profile'
import { api } from '../../services/api'
import { CollectionFolderType, ProfileDataType, TimeLineDataType } from '../../services/apiTypes'
import { Container, ImageBackground, LeftContainer, MasterContainer, Posts } from './styles'

export default function ProfilePage() {
  const [selected, setSelected] = useState('Snipz')
  const [profile, setProfile] = useState<ProfileDataType>();
  const [userPosts, setUserPosts] = useState<TimeLineDataType[]>([]);
  const [userSnipz, setUserSnipz] = useState<TimeLineDataType[]>([]);
  const [userCollections, setUserCollections] = useState<CollectionFolderType[]>([]);
  const [mosaicCols, setMosaicCols] = useState<number>(0);

  useEffect(() => {
    const username = window.location.pathname.split('/').pop()
    try {
      api.get(`/profile/${username}`).then(response => {
        setProfile(response.data);
        if (response.data) {
          // console.log('user profile', response.data);
          setProfile(response.data);
          api.get(`/media/posts/${response.data.userId}`).then(response => {
            // console.log('user posts', response.data);
            setUserPosts(response.data);
          });
          api.get(`/media/snipz/${response.data.userId}`).then(response => {
            // console.log('user snipz', response.data);
            setUserSnipz(response.data);
          });
          api.get(`/collection/folders/`).then(response => {
            // console.log('user collections', response.data);
            setUserCollections(response.data);
          });
        }
      }, error => {
        console.error(error);
      }
      );
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    setMosaicCols(Math.round((window.innerWidth - 400) / 300))
  }, [window.innerWidth]);

  return (
    <MasterContainer>
      <Header />
      <ImageBackground>
        <img
          src={profile?.coverUrl}
          alt="Profile Background"
          style={{ width: '100%', maxHeight: '350px' }}
        />
      </ImageBackground>
      <Container>
        <LeftContainer>
          {profile &&
            <Profile
              avatar={profile}
              userId={profile.userId}
              username={profile.username}
              followers={profile.followersNumber}
              following={profile.followingNumber}
              description={profile.bio}
              links={[]}
            />
          }
        </LeftContainer>
        <Posts>
          <HorizontalMenu selected={selected} setSelected={setSelected} />
          {selected === 'Snipz' && <Mosaic type="profile" columns={3} gap={14} itemData={userSnipz} variant="standard" />}
          {selected === 'Posts' && <Mosaic variant='masonry' type="profile" columns={mosaicCols} gap={14} itemData={userPosts} />}
          {selected === 'Coleção' && <Collection collections={userCollections} />}
          {(selected === 'Studio' || selected === 'Loja' || selected === 'Projetos') && <div style={{ width: '100%' }}>Em construção</div>}
        </Posts>
      </Container>
    </MasterContainer>
  )
}